import { render, staticRenderFns } from "./ImageReader.vue?vue&type=template&id=3477500c&"
import script from "./ImageReader.vue?vue&type=script&lang=js&"
export * from "./ImageReader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports